import React from 'react';
import { Lock, EyeOff, XCircle, ShieldCheck } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function FrictionReduction() {
  const trustItems = [{
    icon: <Lock className="w-8 h-8 text-green-500 mb-3" data-id="element-33" />,
    text: 'Your data is secure'
  }, {
    icon: <EyeOff className="w-8 h-8 text-green-500 mb-3" data-id="element-34" />,
    text: 'No spam, ever'
  }, {
    icon: <XCircle className="w-8 h-8 text-green-500 mb-3" data-id="element-35" />,
    text: 'Unsubscribe anytime'
  }];
  return <section className="py-16 px-4 bg-gray-50 border-t border-gray-100" data-id="element-36">
      <FadeIn className="max-w-4xl mx-auto" data-id="element-37">
        <div className="text-center mb-10" data-id="element-38">
          <ShieldCheck className="w-12 h-12 text-green-500 mx-auto mb-4" data-id="element-39" />
          <p className="text-2xl md:text-3xl font-bold text-gray-800" data-id="element-40">
            No commitment required. Just real prices.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center max-w-3xl mx-auto mb-8" data-id="element-41">
          {trustItems.map((item, index) => <div key={index} className="flex flex-col items-center p-4 bg-white rounded-xl shadow-sm border border-gray-100" data-id="element-42">
              {item.icon}
              <p className="font-semibold text-gray-700" data-id="element-43">{item.text}</p>
            </div>)}
        </div>

        <div className="flex items-center justify-center text-sm text-gray-500 font-medium" data-id="element-44">
          <Lock className="w-4 h-4 mr-2" data-id="element-45" />
          256-bit SSL Encrypted &bull; Your information is protected
        </div>
      </FadeIn>
    </section>;
}